export const attorneys_page = () => {

    let availableMembersList = $("#availableMembersList").DataTable({
        order: [2, 'asc'],
        stateSave: false,
        columnDefs:[
            {
                targets: [1, 2],
                type: 'polstring',
            }
        ]
    });

    if(availableMembersList.length > 0) {
        $("#addAttorney").submit(function (e) {
            e.preventDefault();

            let inputs = availableMembersList.DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="members_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    $("#givenAttorneysTable").DataTable({
        stateSave: false,
        order: [1, 'asc'],
        columnDefs:[
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    });

    $("#grantedAttorneysTable").DataTable({
        stateSave: false,
        order: [1, 'asc'],
        columnDefs:[
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    });

}
